module.exports = __webpack_public_path__ + "9df90d22.png";